import { Component, OnInit } from '@angular/core';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

import { EVENT } from '../../../shared/constants/dali.constants';
import { ForeignCurrencyModel } from '../../../shared/models/abre-cuentas.model';
import { Changes, TagEvent } from '../../../shared/models/dali-tags.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';

const FOREIGN_CURRENCY = 'foreignCurrency';

@Component({
  selector: 'app-foreign-currency',
  templateUrl: './foreign-currency.component.html',
  styleUrls: ['./foreign-currency.component.scss'],
})
export class ForeignCurrencyComponent implements OnInit {

  foreignCurrency = new ForeignCurrencyModel();
  stateButton = false;
  listForeignCurrency: any[];

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private taggingService: TaggingService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private abreCuentasService: AbreCuentasService) {
    this.headerService.show(true, true, true);
    this.listForeignCurrency = [
      { label: copyService.copies.foreign_currency_radio_yes, elementId: 1, checked: false },
      { label: copyService.copies.foreign_currency_radio_no, elementId: 2, checked: true },
    ];
  }

  ngOnInit() {
    this.getData();
  }

  /**
   * Summary Function to charge predefined data by attribute IsPep
   */
  getData() {
    if (this.abreCuentasService.getForeignCurrency() === undefined
      || this.abreCuentasService.getForeignCurrency().elementId === undefined) {
      this.foreignCurrency = {
        elementId: 2,
        value: this.copyService.copies.foreign_currency_radio_no,
        checked: true,
      };
      this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
    } else {
      this.foreignCurrency = this.abreCuentasService.getForeignCurrency();
      for (const foreignCurrency of this.listForeignCurrency) {
        foreignCurrency.checked = foreignCurrency.elementId === this.foreignCurrency.elementId ? this.foreignCurrency.checked : false;
      }
    }
  }

  /**
   * Summary Set propertys to foreignCurrency
   * @param event
   */
  selectradioforeignCurrency(event: any, selectedObject: any) {
    if (event.checked) {
      this.foreignCurrency = {
        elementId: selectedObject.elementId,
        value: selectedObject.label,
        checked: true,
      };
    }

    this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
  }

  clickInfo() {
    this.taggingService.setTagId('', 'pv199', 'pv180', '');
    const tagPageName = this.taggingService.getTagIdByProduct();

    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.header,
          type: EVENT.customCategory.type.tooltip,
          position: EVENT.customCategory.position.top,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`],
      };

      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
    this.sendDataToBitacora();
    if (this.foreignCurrency.elementId === 1) {
      this.navigationService.nextStep('200');
      this.navigationService.getCurrentPhase().steps['foreign-products'].previous = 'operation-currency';
    } else {
      this.navigationService.nextStep('201');
      this.navigationService.getCurrentPhase().steps['foreign-products'].previous = 'foreign-currency';
    }
  }

  sendDataToBitacora() {
    const strDataToSend = `${FOREIGN_CURRENCY} ` + (this.foreignCurrency.elementId === 1) ? 'Si' : 'No';
    this.bitacoraService.saveDataInBitacora(strDataToSend);
  }

}
